/** Rend une valeur de ligne affichable et filtrable, `null` compris. */
export function text(value: unknown): string {
  return value == null ? '' : String(value);
}

/** Champ numérique de popup : vide ou illisible devient `0`, la virgule décimale est acceptée. */
export function numberOrZero(value: string): number {
  const parsed = Number(value.trim().replace(',', '.'));
  return value.trim().length && isFinite(parsed) ? parsed : 0;
}

/** Filtre plein texte sur les colonnes affichées, comme le fait chaque référentiel. */
export function matchesTerm<T>(row: T, keys: readonly string[], term: string): boolean {
  if (!term) return true;
  return keys.some(key => text((row as Record<string, unknown>)[key]).toLowerCase().includes(term));
}

/**
 * Recherche sur un nom complet. Les deux ordres sont acceptés — « prénom nom »
 * comme « nom prénom » —, sinon une saisie à deux mots ne trouverait rien : aucun
 * champ pris isolément ne contient les deux.
 */
export function matchesFullName(
  firstName: string | null | undefined,
  lastName:  string | null | undefined,
  term:      string,
): boolean {
  if (!term) return true;

  const needle = term.replace(/\s+/g, ' ');
  const first  = text(firstName).trim().toLowerCase();
  const last   = text(lastName).trim().toLowerCase();

  return `${first} ${last}`.trim().includes(needle)
      || `${last} ${first}`.trim().includes(needle);
}

export const SETTINGS_DETAIL = 'information';

/** Coordonnées exploitables par la carte : finies et dans les bornes WGS84. */
export function isValidLonLat(lon: number, lat: number): boolean {
  return isFinite(lon) && isFinite(lat)
    && lon >= -180 && lon <= 180
    && lat >= -90  && lat <= 90;
}
